import { loadImportPreview, resumeQueuedImport, watchQueuedImport } from './importpreview';
import { ajaxPromise, checkChosenChanged, confirmDialog, displayNotification, logerror, post, toggleSlide } from './utils';

if ($('#contract_import_form').length === 1) {
    init_contract_import();
}

function init_contract_import() {
    let uploadResponse: any = null;
    let guid: string | null = null;
    let previewTable: DataTables.Api | null = null;
    
    // initialize options / filters
    $('#contract_import_filter_container select.chosen').chosen({ width: '100%' });
    toggleSlide($('#contract_import_filter_toggle'), $('#contract_import_filter_container'));
    checkChosenChanged($('#contract_import_filter_container select.chosen'));
    $('#contract_import_filter_container select.chosen').on('change', ({ target }) => checkChosenChanged($(target)));

    // If a default vendor is preselected show the options
    const preselectedVendor = $('#contract_import_preselected_vendor').val();
    if (preselectedVendor) {
        $('#contract_import_filter_container').slideDown();
        $('#contract_import_filter_toggle i').removeClass('fa-caret-down').addClass('fa-caret-up');
        $('#contract_import_default_vendor').val(preselectedVendor as string).trigger('chosen:updated');
    }

    // Cancel / Back to vendor button
    $('#contract_import_cancel').off('click').on('click', () => {
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        if (preselectedVendor) {
            post('/ui/vendor_edit', { id: preselectedVendor, start: 'contracts' });
            return;
        }
        window.location.href = '/ui';
    });

    // Reset filters
    $('#contract_import_filter_reset').on('click', () => {
        $('#contract_import_default_vendor').val('').trigger('chosen:updated');
        $('#contract_import_auto_create_categories').val('1');
        checkChosenChanged($('#contract_import_default_vendor'));
    });

    // Download template
    $('#contract_import_download_template').on('click', () => window.location.href = '/data/contracts_template');

    const showUploadForm = () => {
        $('#contract_import_upload_section').show();
        $('#contract_import_preview_section').hide();
        $('#contract_import_commit_status').hide();
        $('#contract_import_commit, #contract_import_discard').prop('disabled', false);
    };

    const showPreview = () => {
        $('#contract_import_upload_section').hide();
        $('#contract_import_preview_section').show();
    };

    // Upload form submit (Preview)
    $('#contract_import_test').on('click', async function () {
        const fileInput = $('#contract_import_file')[0] as HTMLInputElement;
        if (!fileInput.files || !fileInput.files.length) {
            displayNotification('No File', 'Please select a file first.', 'warning');
            return;
        }

        const formData = new FormData();
        formData.append('file', fileInput.files[0]);
        formData.append('mode', '0'); // Preview mode
        
        // Add options
        const defaultVendorId = $('#contract_import_default_vendor').val();
        if (defaultVendorId) {
            formData.append('default_vendor_id', defaultVendorId as string);
        }
        
        const autoCreateCategories = $('#contract_import_auto_create_categories').val() as string;
        formData.append('auto_create_categories', autoCreateCategories);

        $('#contract_import_spinner').show();
        $('#contract_import_test').prop('disabled', true);

        try {
            const response = await ajaxPromise('/import/contract_upload', formData);
            $('#contract_import_spinner').hide();
            $('#contract_import_test').prop('disabled', false);

            if (response.msgs) {
                uploadResponse = response;
                previewTable = loadImportPreview({
                    prefix: 'contract_import',
                    uploadResponse: response,
                    existingTable: previewTable,
                    showPreview,
                });
                displayNotification('Upload Failed', 'The spreadsheet format is invalid. Please check the errors.', 'danger');
                return;
            }

            if (response.rc === 'OK') {
                guid = response.guid;
                uploadResponse = response;
                previewTable = loadImportPreview({
                    prefix: 'contract_import',
                    uploadResponse: response,
                    existingTable: previewTable,
                    showPreview,
                });
                displayNotification('Upload Successful', 'Please review the changes before confirming.', 'success');
            } else {
                displayNotification('Upload Failed', response.message || response.msg || 'The import test failed. Please check your file.', 'danger');
            }
        } catch (error) {
            $('#contract_import_spinner').hide();
            $('#contract_import_test').prop('disabled', false);
            displayNotification('Error', 'An error occurred while processing the file.', 'danger');
            logerror('contract import test', error);
        }
    });

    // Commit Import
    $('#contract_import_commit').on('click', async function () {
        if (!guid) {
            displayNotification('Preview Required', 'Please run a preview first.', 'warning');
            return;
        }

        // Double-check for errors before allowing commit
        const { preview } = uploadResponse;
        const hasErrors = preview && preview.some((row: any) => row.errors && row.errors.length > 0);
        if (hasErrors) {
            displayNotification('Errors Present', 'Cannot confirm import with validation errors. Please fix your spreadsheet and re-upload.', 'danger');
            return;
        }

        const confirmed = await confirmDialog({
            dialogTitle: 'Confirm Import',
            bodyText: 'Are you sure you want to confirm this import? This action cannot be undone.',
            confirmText: 'Confirm Import',
            confirmStyle: 'success',
        });

        if (!confirmed) {
            return;
        }

        const formData = new FormData();
        formData.append('guid', guid);
        formData.append('mode', '1'); // Commit mode
        
        // Include the auto-create option for commit
        const autoCreateCategories = $('#contract_import_auto_create_categories').val() as string;
        formData.append('auto_create_categories', autoCreateCategories);

        $('#contract_import_commit, #contract_import_discard').prop('disabled', true);

        try {
            const response = await ajaxPromise('/import/contract_upload', formData);
            if (!response.queued) {
                $('#contract_import_commit, #contract_import_discard').prop('disabled', false);
                displayNotification('Import Failed', response.message || response.msg || 'The import failed.', 'danger');
                return;
            }

            $('#contract_import_commit_status_text').text('Import queued. You can leave this page. Coming back will show whether it is still running.');
            $('#contract_import_commit_status').show();

            const result = await watchQueuedImport(guid);
            if (result.state === 'done') {
                displayNotification('Import Complete', 'Contracts have been successfully imported.', 'success');
                const formElement = $('#contract_import_form')[0] as HTMLFormElement;
                formElement.reset();
                uploadResponse = null;
                $('.file-text').text('Choose a file or drag it here');
                showUploadForm();
            } else if (result.state === 'waiting') {
                $('#contract_import_commit_status i').removeClass('fa-spin fa-spinner').addClass('fa-clock-o');
                $('#contract_import_commit_status_text').text(result.msg);
                displayNotification('Import Still Running', result.msg, 'info');
            } else {
                $('#contract_import_commit_status').hide();
                $('#contract_import_discard').prop('disabled', false);
                displayNotification('Import Failed', result.msg, 'danger');
            }
        } catch (error) {
            $('#contract_import_commit_status').hide();
            $('#contract_import_commit, #contract_import_discard').prop('disabled', false);
            displayNotification('Error', 'An error occurred while committing the import.', 'danger');
            logerror('contract import commit', error);
        }
    });

    // Discard changes and go back to upload form
    $('#contract_import_discard').on('click', async function () {
        const confirmed = await confirmDialog({
            dialogTitle: 'Discard Changes',
            bodyText: 'Are you sure you want to discard these changes?',
            confirmText: 'Discard',
            confirmStyle: 'warning',
        });

          if (confirmed) {
              if (guid) {
                  try {
                      const response = await ajaxPromise('/import/discard', { guid });
                      if (response.rc !== 'OK') {
                          displayNotification('Discard Failed', response.msg || response.message || 'This preview could not be discarded.', 'danger');
                          return;
                      }
                  } catch (error) {
                      logerror('contract import discard', error);
                      displayNotification('Discard Failed', 'This preview could not be discarded.', 'danger');
                      return;
                  }
              }

            const formElement = $('#contract_import_form')[0] as HTMLFormElement;
            formElement.reset();
            uploadResponse = null;
            guid = null;
            $('.file-text').text('Choose a file or drag it here');
            showUploadForm();
        }
    });

    // Reset commit button when file changes
    $('#contract_import_file').on('change', function () {
        uploadResponse = null;

        // Update the file label text
        const fileInput = this as HTMLInputElement;
        const fileLabel = $('.file-text');
        if (fileInput.files && fileInput.files.length > 0) {
            fileLabel.text(fileInput.files[0].name);
        } else {
            fileLabel.text('Choose a file or drag it here');
        }
    });

    resumeQueuedImport('contract_import', 'contract', 'Contracts have been successfully imported.');
}
